<template>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0538 20.9628C9.49518 20.3324 3.96059 13.032 4.15156 7.36961C4.22971 5.05248 7.41477 3.35051 8.45363 2.87517L11.8313 8.20856L9.40373 9.86651C8.92629 11.8919 11.5425 15.2277 13.2281 15.7949L16.3595 13.9291L19.7713 18.9153C19.5838 19.4193 16.7157 21.6115 13.0538 20.9628Z" fill="#007893"/>
  </svg>
</template>
